import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { CookieService } from 'ngx-cookie-service';
import { project } from 'src/app/Models/BasicForms/project';
import { ApiService } from 'src/app/Service/api.service';
import { ProjectMappingComponent } from '../../ProjectM/project-mapping/project-mapping.component';

@Component({
  selector: 'app-kanban',
  templateUrl: './kanban.component.html',
  styleUrls: ['./kanban.component.css'],
  providers: [DatePipe]
})

export class KanbanComponent implements OnInit {
  constructor(private router: Router, public _apiService: ApiService, private notificationService: NzNotificationService, private datePipe: DatePipe, public cookie: CookieService) { }

  formTitle = "Projects";

  ngOnInit(): void {
    this.getAllProjects();
    this.loadAllClients();
    this.getDefaultProject();

    this.logtext = 'OPENED - Kanban form KEYWORD[O - Kanban] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
      if (successCode['code'] == "200") {

      }
      else {

      }
    });
  }

  pageIndex = 1;
  pageSize = 6;
  totalRecords = 1;
  sortValue: string = "desc";
  logtext: string = "";
  searchText: string = "";
  columns: string[][] = [["ABBREVATION", "Abbrevation"], ["NAME", "Name"]];
  filterQuery: string = "";
  isProjectSpinning = false;
  loadingRecords = false;
  projectData: [];
  noMoreProjects = true;

  getAllProjects(reset: boolean = false) {
    this.noMoreProjects = true;

    if (reset) {
      this.pageIndex = 1;
    }

    this.loadingRecords = true;
    var sort: string;
    try {
      sort = this.sortValue.startsWith("a") ? "asc" : "desc";
      this.logtext = 'Filter Applied - Project Master form"+ sort +" "+this.sortKey +" KEYWORD [F - Project Master] ';
      this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
        if (successCode['code'] == "200") {

        }
        else {

        }
      });
    } catch (error) {
      sort = "";
    }



    if (this.searchText != "") {
      if (this.cookie.get("level") == "1" || this.cookie.get("level") == "2" || this.cookie.get("level") == "3") {
        var likeQuery = " AND";
        this.columns.forEach(column => {
          likeQuery += " " + column[0] + " like '%" + this.searchText + "%' OR";
        });

        likeQuery = likeQuery.substring(0, likeQuery.length - 2);

      } else {
        var likeQuery = " AND (";
        this.columns.forEach(column => {
          likeQuery += " " + column[0] + " like '%" + this.searchText + "%' OR";
        });

        likeQuery = likeQuery.substring(0, likeQuery.length - 2);
        likeQuery = likeQuery + ")";
      }


    }

    this.logtext = 'Filter Applied - Category Master form "+ likeQuery +" KEYWORD [F - Category Master] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
      if (successCode['code'] == "200") {

      }
      else {

      }
    });

    this.applyFilter();

    if (this.cookie.get("level") == "1" || this.cookie.get("level") == "2" || this.cookie.get("level") == "3") {
      var filter = ""
      if (likeQuery)
        filter = this.filterQuery + likeQuery;
      else
        filter = this.filterQuery;

    } else {
      var filter = ""
      if (likeQuery)
        filter = " and USER_ID=" + this._apiService.userId + " and IS_ACTIVE=1" + this.filterQuery + likeQuery;

      else
        filter = " and USER_ID=" + this._apiService.userId + " and IS_ACTIVE=1" + this.filterQuery;
    }


    this.isProjectSpinning = true

    if (this.cookie.get("level") == "1" || this.cookie.get("level") == "2" || this.cookie.get("level") == "3") {
      this._apiService.getAllProjects(this.pageIndex, this.pageSize, 'START_DATE', 'desc', filter).subscribe(data => {

        this.isProjectSpinning = false;
        this.totalRecords = data['count'];
        this.projectData = data['data'];

        if (this.totalRecords == this.projectData.length) {
          this.noMoreProjects = false;
        }

      }, err => {

        if (err['ok'] == false)
          this.notificationService.error("Server Not Found", "");
      });

    } else {
      this._apiService.getAllMappedProjects(this.pageIndex, this.pageSize, 'START_DATE', 'desc', filter).subscribe(data => {

        this.isProjectSpinning = false;
        this.totalRecords = data['count'];
        this.projectData = data['data'];

        if (this.totalRecords == this.projectData.length) {
          this.noMoreProjects = false;
        }

      }, err => {

        if (err['ok'] == false)
          this.notificationService.error("Server Not Found", "");
      });
    }
  }

  drawerVisible = false;
  mappingDrawerVisible = false;
  drawerTitle = "";
  mappingDrawerTitle = "";
  projectDrawerData: project = new project();
  showWorkLogsLink = false;

  add() {
    this.drawerTitle = "Create Project";
    this.projectDrawerData = new project();
    this.drawerVisible = true;
    this.showWorkLogsLink = false;
    this.projectDrawerData.IS_ACTIVE = true;

    this.logtext = 'ADD - Project Master form KEYWORD [A - Project Master] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
      if (successCode['code'] == "200") {

      }
      else {

      }
    });
  }

  sortKey: string = "id";

  sort(params: NzTableQueryParams): void {
    const { pageSize, pageIndex, sort } = params;
    const currentSort = sort.find(item => item.value !== null);
    const sortField = (currentSort && currentSort.key) || 'id';
    const sortOrder = (currentSort && currentSort.value) || 'desc';



    this.pageIndex = pageIndex;
    this.pageSize = pageSize;

    if (this.pageSize != pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    if (this.sortKey != sortField) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    this.sortKey = sortField;
    this.sortValue = sortOrder;
    this.getAllProjects();
  }

  projectClientList = [];

  loadAllClients() {
    this._apiService.getAllClients(0, 0, 'ID', 'desc', ' and IS_ACTIVE=1').subscribe(clientData => {
      this.projectClientList = clientData['data'];

    }, err => {

    });
  }

  filterClass: string = "filter-invisible";
  isFilterApplied: string = "default";

  applyFilter() {
    if (this.PROJECT_DATE != null) {
      var startDate = this.datePipe.transform(this.PROJECT_DATE[0], "yyyy-MM-dd");
      var endDate = this.datePipe.transform(this.PROJECT_DATE[1], "yyyy-MM-dd");

      this.filterQuery = " AND START_DATE between '" + startDate + "'" + " AND '" + endDate + "'"


      this.isFilterApplied = "primary";
      this.filterClass = "filter-invisible";

    } else {
      this.filterQuery = ""
    }
  }

  showFilter(): void {
    if (this.filterClass === "filter-visible")
      this.filterClass = "filter-invisible";
    else
      this.filterClass = "filter-visible";
  }

  clearFilter() {
    this.filterQuery = "";
    this.PROJECT_DATE = null;

    this.isFilterApplied = "default";
    this.filterClass = "filter-invisible";

    this.getAllProjects();
  }

  PROJECT_DATE = null;

  loadMoreProjects() {
    this.pageSize = this.pageSize + 3;
    this.getAllProjects();
  }

  isKanbanModalVisible = false;
  kanbanModalName: string;

  openKanbanModal(projectInfo: project) {
    // this.isKanbanModalVisible= true;
    // this.kanbanModalName= projectInfo.NAME;

    if (this.cookie.get("level") == "1" || this.cookie.get("level") == "2" || this.cookie.get("level") == "3") {
      this.router.navigate(['/projectID', projectInfo['ID']]);

    } else {
      this.router.navigate(['/projectID', projectInfo['PROJECT_ID']]);
    }

    sessionStorage.setItem("projectID", projectInfo.ID.toString());
    this.getDefaultProject();
  }

  defaultProjectID: any;

  getDefaultProject() {
    this.defaultProjectID = sessionStorage.getItem('projectID');

    if (this.defaultProjectID == null) {
      this.defaultProjectID = 1;
      sessionStorage.setItem("projectID", this.defaultProjectID);
    }
  }

  kanbanMadalCancel() {
    this.isKanbanModalVisible = false;
  }

  edit(data: project) {
    this.drawerTitle = "Project Details";
    this.projectDrawerData = Object.assign({}, data);
    this.drawerVisible = true;
    this.showWorkLogsLink = true;

    this.logtext = 'EDIT - Project Master form KEYWORD [E - Project Master] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
      if (successCode['code'] == "200") {

      }
      else {

      }
    });
  }

  drawerClose() {
    this.getAllProjects();
    this.drawerVisible = false;
    this.showWorkLogsLink = null;
  }

  get callBackDrawerClose() {
    return this.drawerClose.bind(this);
  }

  mappingDrawerClose() {
    this.mappingDrawerVisible = false;
  }

  get callBackMappingDrawerClose() {
    return this.mappingDrawerClose.bind(this);
  }

  projectMappingDrawerData: [];
  @ViewChild(ProjectMappingComponent) ProjectMappingComponentVar: ProjectMappingComponent;

  MapForms(data: project): void {
    this.ProjectMappingComponentVar.loadingRecords = true;

    this._apiService.getProjectDetails(data.ID, 1).subscribe(data => {
      this.ProjectMappingComponentVar.loadingRecords = false;

      this.projectMappingDrawerData = data['data'];

    }, err => {

    });

    this.projectDrawerData = Object.assign({}, data);
    this.mappingDrawerTitle = data.NAME;
    this.mappingDrawerVisible = true;
    this.ProjectMappingComponentVar.TASK_CATEGORY_ID = 1;
  }

  onEnterGetAllProjects() {
    document.getElementById("button1").focus();
    this.getDefaultProject();
  }
}
